export const triangleArrow = (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.02756 1.30467V11.1769C7.02756 11.8605 6.12994 12.2028 5.60498 11.7194L0.244063 6.78334C-0.0813542 6.48371 -0.0813542 5.99786 0.244063 5.69823L5.60498 0.762115C6.12994 0.278717 7.02756 0.621085 7.02756 1.30467Z" fill="#333333" fill-opacity="0.8"/>
    </svg>
);
